import { useState } from 'react';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Modal } from '../modal';
import MemoryButton from '../memory-button';
import { flashcardService } from '../../queries';
import { useUserStore } from '../../../Auth/stores/authStore';
import { toast } from '../../../../core/components/atoms/Toast';
import { FlashcardVariants } from './variants';
import { Colors } from '../../../../core/models/disciplines';
import { DISCIPLINES_MAP } from '../../constants';

const Flashcard = ({
  uuid,
  title,
  icon,
  onEdit,
  isSelected,
  isDeleteMode,
  onSelect,
  onCallbackSuccess,
  discipline,
  subject,
}: {
  uuid: string;
  title: string;
  color?: string;
  icon?: string;
  onEdit: () => void;
  isSelected?: boolean;
  isDeleteMode?: boolean;
  onSelect?: VoidFunction;
  onCallbackSuccess?: VoidFunction;
  discipline?: string;
  subject?: string;
}) => {
  const { user } = useUserStore();
  const userUuid = user?.memoryUserUuid;
  const [openModalDelete, setOpenModalDelete] = useState(false);

  const onClickFunction = () => (isDeleteMode ? onSelect?.() : onEdit?.());

  const handleDelete = async () => {
    if (!userUuid) return;
    try {
      const response = await flashcardService.delete(userUuid, uuid);
      toast({
        title: 'Flashcard deletado com sucesso',
        message: response.message,
        variant: 'success',
      });
      onCallbackSuccess?.();
      setOpenModalDelete(false);
    } catch (error) {
      console.log('error', error);
      toast({
        title: 'Erro ao deletar flashcard',
        message: 'Ocorreu um erro ao deletar o flashcard',
        variant: 'error',
      });
    }
  };

  const bgImage =
    DISCIPLINES_MAP[discipline as keyof typeof DISCIPLINES_MAP].bgImage;

  return (
    <div className='relative'>
      {isDeleteMode && (
        <div
          onClick={() => setOpenModalDelete(true)}
          className='absolute right-[-8px] top-[-10px] flex h-[20px] w-[20px] cursor-pointer items-center justify-center rounded-circular bg-card-color-default text-mono-color-black'
          style={{ zIndex: 1000 }}
        >
          <Icon
            type='material'
            Icon='close'
            className='text-sm text-mono-color-black dark:text-[#000]'
          />
        </div>
      )}
      <div
        onClick={onClickFunction}
        className={FlashcardVariants({
          color: discipline as Colors,
          isSelected,
        })}
      >
        <div className='h-[55px] w-[93px]'>
          <img
            src={icon || bgImage}
            alt='Imagem de Login'
            className='h-full w-full object-contain'
          />
        </div>

        {subject && (
          <div className='mx-1 flex items-center justify-center rounded-md bg-color-modal-conteudo px-2 py-1'>
            <Typography className='line-clamp-2 text-ellipsis text-xs text-mono-color-darkest'>
              {subject}
            </Typography>
          </div>
        )}
        <Typography className='line-clamp-2 text-ellipsis px-2 text-center text-sm font-bold text-[#FFF]'>
          {title}
        </Typography>
      </div>
      <ModalDelete
        isOpen={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        onDelete={handleDelete}
      />
    </div>
  );
};

export default Flashcard;

const ModalDelete = ({
  isOpen,
  onClose,
  onDelete,
}: {
  isOpen: boolean;
  onClose: VoidFunction;
  onDelete: VoidFunction;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <Typography className='dark:text-[#FFF]'>
          Excluir <i>flashcard</i>
        </Typography>
      }
      footer={
        <div className='flex gap-2'>
          <MemoryButton
            label='Cancelar'
            variant='outline'
            className='w-full'
            onClick={onClose}
            allowReadOnly
          />
          <MemoryButton
            label='Apagar'
            className='w-full bg-color-brand-primary'
            variant='primary'
            onClick={onDelete}
          />
        </div>
      }
    >
      <div>
        <Typography>
          Tem certeza que deseja excluir este <i>flashcard</i>?
        </Typography>
      </div>
    </Modal>
  );
};
